import equipmentRouter from './equipment.router';
import softwareProductsRouter from './softwareProducts.router';
import solutionRouter from './solution.router';
import aboutRouter from './about.router';
import newsRouter from './news.router';

export const router_general = [//通用
	// 登录页
	{
		path: '/login',
		name: 'login',
		meta: {
			title: '登录'
		},
		component: () => import('views/login/index.vue'),
	},
	{
		path: '',
		name: 'home',
		meta: {
			title: '模板一'
		},
		component: () => import('views/templateOne/index.vue'),
		redirect: '/',
		children: [

			// 首页
			{
				path: '/',
				name: 'home',
				meta: {
					title: '首页',
					// title2: 'AI智慧食堂-食品溯源-生鲜食材配送-校园食品安全-华略未来科技'
				},
				component: () => import('views/home/index.vue'),
			},

			...softwareProductsRouter, // 软件产品

			...solutionRouter, // 解决方案
			...aboutRouter, // 关于我们

			...equipmentRouter, // 智能硬件
			...newsRouter, // 新闻
		],
	},
	// {
	// 	path: '/test',
	// 	name: 'test',
	// 	meta: {
	// 		title: '测试'
	// 	},
	// 	component: () => import('views/test/index.vue'),
	// 	children: [
	// 	],
	// },
	{
		path: '/*',
		name: 'error-404',
		meta: {
			title: '404-页面不存在'
		},
		component: () => import('views/errorPage/404.vue'),
		children: [
		],
	}
]

export const routerConfig = [...router_general];
